import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20inviting%20living%20room%20with%20two%20cats%20playing%20together%20on%20a%20soft%20rug%2C%20golden%20afternoon%20light%2C%20cream%20and%20beige%20interior%2C%20cozy%20atmosphere%2C%20peaceful%20and%20warm%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20artistic%20photography&width=1600&height=700&seq=cta-cat-community&orientation=landscape"
        alt="加入猫咪社区"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      <div className="relative z-10 max-w-[600px] mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-4xl font-heading text-white mb-4">
          {t("join_community")}
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 leading-relaxed">
          {t("join_community_desc")}
        </p>
        <Link
          to="/about"
          className="inline-block px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
        >
          {t("join_btn")}
        </Link>
      </div>
    </section>
  );
}